export class CallMeBack {
    date: string;
    hour: string;
    topic: string;
    policy: string | null = null;
    claim: string | null = null;
    agreement: boolean;
    errors: object;
    source: string | null = null;
}
